import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Grid from "@mui/material/Grid";
import RadioGroup from "@mui/material/RadioGroup";
import React, { useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { connect, useSelector } from "react-redux";
import CustomRadio from "../../../components/CustomRadio";
import FormLayout from "../../../components/FormLayout";
import { userSetupSlice, UserSetupState, UserSetupSubstep } from "../../../store/reducer/user_setup";
import AddressForm from "./AddressForm";
import { userSlice } from "../../../store/reducer/user";
import CustomButton from "../../../components/CustomButton";
import { Dispatch } from "redux";
import { User } from "../../../model/user";
import { Address, defaultAddress } from "../../../model/address";
import { goBack } from "redux-first-history";
import { RootState } from '../../../store/index';
import { locationApi } from "../../../api/LocationApi";

interface AddressVerificationFormGroupProps {
  user: User,
  userSetupState: UserSetupState,
  dispatch: Dispatch<any>
}

/**
 * This used to also ask whether they lived
 * at the address full-time, but client wanted to
 * remove that.
 */
const AddressVerificationFormGroup = ({
  dispatch,
  user,
  userSetupState
}: AddressVerificationFormGroupProps) => {
  let [address, setAddress] = useState<Address>(defaultAddress);
  const currentTaxYear = useSelector((state: RootState) => state.state.taxYear);

  return (
    <FormLayout
      title={"Other Address"}
      subtitle={""}
      description={
        `Please enter the other address at which you lived during ${currentTaxYear}.`
      }
    >
      <ValidatorForm
        onSubmit={() => {
          dispatch(userSlice.actions.updateUserData({...address}));
          dispatch(userSetupSlice.actions.clearSubstepErrors(UserSetupSubstep.VerifyAddress));
          dispatch(userSetupSlice.actions.confirmStep());
        }}
      >
        <Grid
          container
          spacing={2}
          className='form-container xl noexpand'
          sx={{ marginBottom: '1.6rem'}}
        >
          <AddressForm
            address={address}
            setAddress={setAddress}
          />
        </Grid>
        <div className='btn-container'>
          <CustomButton
            variant="outlined"
            disableElevation={false}
            label={"back"}
            onClick={() => dispatch(goBack())}
            buttonSize='btn-lg'
          />
          <CustomButton
            variant="contained"
            disableElevation={true}
            label={"next"}
            type="submit"
            buttonSize="btn-lg"
          />
        </div>
      </ValidatorForm>
    </FormLayout>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    userSetupState: state.userSetup
  };
};

export default connect(mapStateToProps)(AddressVerificationFormGroup);

//export default AddressVerificationFormGroup;
